import React from 'react';

import {TEXT_DIMENSIONS} from '../constants';
import type {BoneTextProps} from '../types';

import {Bone} from './Bone';

export const BoneText: React.FC<BoneTextProps> = React.memo(({variant, width, ...rest}) => {
  const dims = TEXT_DIMENSIONS[variant];
  return (
    <Bone
      width={width ?? dims.defaultWidth}
      height={dims.height}
      borderRadius={dims.borderRadius}
      {...rest}
    />
  );
});
BoneText.displayName = 'BoneText';
